












































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import {
  CloudFile,
  FetchState
} from "@/shared/types";
import FileUpload from "vue-upload-component";
import { useCloudfileStore } from "@/shared/store/cloudfile";

@Component({
  components: {
    FileUpload
  }
})
export default class S3Uploader extends Vue {
  $validator: Validator;
  cloudFileStore = useCloudfileStore();

  @Prop()
  bucketName: string;
  @Prop()
  fileKey: string;
  @Prop()
  identifier: string;
  @Prop()
  disabled: boolean;

  fileName = null;
  uploadErrors = [];

  formModel: CloudFile = {
    status: FetchState.Uninitialized,
    remoteFileName: this!.fileKey,
    remoteAddress: this!.bucketName,
    payload: null
  };

  get fileNameDisplay (): string {
    return this.fileName ? this.fileName : "No file selected";
  }

  inputFilter (newFile, oldFile, prevent) {
    if (this.disabled) {
      return;
    }
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (!/\.(csv)$/i.test(newFile.name)) {
        this.uploadErrors.push("File type not allowed.");
        this.fileName = null;
        return prevent();
      } else {
        this.fileName = newFile.name;
      }
    }
  }

  uploadFile (selectedFile) {
    if (!selectedFile || this.disabled) {
      return;
    }
    this.formModel.payload = selectedFile.file;
    this.cloudFileStore.upload({
          key: this.identifier,
          file: this.formModel
        })
        .then(file => this.$emit("success", file))
        .catch(err => {
          this.$emit("error", err);
          return;
        });
  }

}
